export default "__VITE_ASSET__C8$mhUGM__"